//
// Module for list detail functionality
//
rs.module("controls/list/detail",

    ["controls/components/event-banner"],

    function (eventBanner) {

        let hostingListIndicator = "hostingListApi";

        // Initialize the module
        function initialize(jsSelectors, cssClasses, showingDetailOnLoad, listApiAccessor) {

            var detailContainer = $.js(jsSelectors.detailContainer);
            var eventBannerContainer = detailContainer.js(jsSelectors.eventBannerContainer);
            var mobileHeader = detailContainer.js(jsSelectors.mobileHeader);
            var title = detailContainer.js(jsSelectors.title, { multiple: true });
            var contentContainer = detailContainer.js(jsSelectors.contentContainer);
            var content = detailContainer.js(jsSelectors.content);
            var skeleton = detailContainer.js(jsSelectors.skeleton);
            var headerActionsHolder = detailContainer.js(jsSelectors.headerActionsHolder);
            var mobileHeaderActionsHolder = detailContainer.js(jsSelectors.mobileHeaderActionsHolder);

            _setActionBar();

            // If the detail view is open on load, we want to show the event banner in the detail view
            _showEventBannerInDetail($.isMobile() && detailContainer.hasClass(cssClasses.open), true);

            // Reevaluate where to show the event banner as the window resizes
            $(window).resize(_.debounce(function () {
                _showEventBannerInDetail($.isMobile() && detailContainer.hasClass(cssClasses.open), true);
                _setActionBar();
            }, 200));

            // Add scroll shadow when detail is scrolled
            detailContainer.scroll(function () {
                mobileHeader.toggleClass(cssClasses.scrollShadow, $(this).scrollTop() > 0);
            });

            // attach events to list items to trigger this detail
            attachEvents($.js(jsSelectors.listItem, { required: false, multiple: true }));

            // The brower POST is going to automatically add its own history item, with no state.  We want to propagate our current
            // "detail" state across the post (with its counter), so we'll temporarily store it in session storage.
            $("body").on("submit", "form", function (e) {
                if (history.state && history.state.rsId === "#detail") {
                    var rsHistoryState = history.state;
                    rsHistoryState.counter++;
                    sessionStorage.historyStateToRestore = JSON.stringify(rsHistoryState);
                }
            });

            // If the prior POST pushed a history state into session storage, restore it now
            if (sessionStorage.historyStateToRestore) {

                var rsHistoryState = JSON.parse(sessionStorage.historyStateToRestore);

                // If the control is displaying detail on load, after a post (historyStateToRestore has a value), restore the temporarily saved saved history state
                if (showingDetailOnLoad) {
                    history.replaceState(rsHistoryState, "");
                }

                sessionStorage.removeItem("historyStateToRestore");
            }
            else {
                // If we're getting initialized, it's a load.  If history thinks we're in a detail, navigate back to reset that history
                if (history.state && history.state.rsId === "#detail" && !showingDetailOnLoad) {
                    var rsHistoryState = history.state;
                    if (rsHistoryState && rsHistoryState.counter > 0) {
                        history.go(-1 * (rsHistoryState.counter));
                    }
                }
            }

            // Hookup detail header back button click
            $.js(jsSelectors.backButton).click(function () {

                // Move event banner back to main page
                _showEventBannerInDetail(false, false);

                // Close the detail popover
                detailContainer.removeClass(cssClasses.open);

                if ($.isMobile()) {
                    // Since we pushed a new state to history when the detail was opened,
                    // we need to go back 1 in history if the header back button is used to go back (as oppossed to the browser back button)
                    var rsHistoryState = history.state;
                    if (rsHistoryState && rsHistoryState.counter > 0) {
                        history.go(-1 * (rsHistoryState.counter));
                    }
                }
            });

            // This is fired when the active history entry changes while the user navigates the session history. This only
            // fires for the history entries pushed/replaced in the same document instance, which notable is NOT the case
            // when a page POSTS and is re-loaded.  So after a POST, if the user clicks the back button, this is not fired.
            // There is hope that with the currently-experimental Navigation API, this can be reimplemented to get full featured
            // browser-back-button interception.
            window.addEventListener("popstate", function (event) {

                // When we open a detail page, we are using pushState to insert a history entry with the state of '#detail'
                // When one of those history entries is accessed, this event will fire and event.state will be '#detail'
                // Given that, we know that if event.state == null, then we are on a normal page and not a detail popover - position event banner accordingly
                var isDetailState = event.state != null && event.state.rsId == "#detail";

                _showEventBannerInDetail($.isMobile() && isDetailState, false);

                // Toggle detail popover
                detailContainer.toggleClass(cssClasses.open, isDetailState);
            });

            // Convenience method to show the event banner in the detail popover or on the main page
            function _showEventBannerInDetail(showInDetail, maintainMessages) {

                // optionally clear all messages
                if (!maintainMessages) {
                    eventBanner.removeAllMessages();
                }

                eventBanner.html().prependTo(showInDetail ? eventBannerContainer : $('.page-content__main'));
            }

            // Set the action bar to display in mobile header or card header based on if we are on mobile
            function _setActionBar() {
                if ($.isMobile()) {
                    mobileHeaderActionsHolder.append($(`[data-js='${jsSelectors.headerActions}']`));
                }
                else {
                    headerActionsHolder.append($(`[data-js='${jsSelectors.headerActions}']`));
                }
            }

            // Initialize the detail section - this includes:
            // showing detail popover on mobile, showing the loading skeleton, setting event banner placement, and pushing state to history
            // This is also exposed as an API function
            function initializeDetail() {

                // Detail header actions can be conditional depending on the detail being loaded
                // Since we are showing the detail page immediately and then loading in the detail asynchronously,
                // when we initially open the detail, we want to empty the action bar of any actions that may have been shown from any previous detail
                headerActionsHolder.empty();
                mobileHeaderActionsHolder.empty();

                // Set the the event banner to display in the detail popover if on mobile
                if ($.isMobile()) {
                    _showEventBannerInDetail(true);
                }

                // Show the detail popover
                detailContainer.addClass(cssClasses.open);
                contentContainer.show();

                // Show skeleton in the popover initially
                content.hide();
                skeleton.show();

                if ($.isMobile()) {
                    // Push state to history when detail is shown so that browser back button will close detail instead of going back to the previous page
                    window.history.pushState({ rsId: "#detail", counter: 0 }, "");
                }
            }

            // Attach events to list items to trigger this detail
            // This is also exposed as an API function
            function attachEvents(listItems) {

                // Add the _clickable class to all of the detail items
                listItems.addClass(cssClasses.clickable);

                // We want to select list items that will be associated with the list's detail
                // hrefs indicate list items that will redirect rather than show a list detail, so we'll filter them out
                // as well as items marked disabled
                var detailItems = listItems.filter(`:not([href]):not(.${cssClasses.disabled})`); 

                detailItems.attr("tabindex", "0");

                // Listen for click events on list items
                detailItems.on("click enterpressed", function () {

                    // Detail header actions can be conditional depending on the detail being loaded
                    // Since we are showing the detail page immediately and then loading in the detail asynchronously,
                    // when we initially open the detail, we want to empty the action bar of any actions that may have been shown from any previous detail
                    headerActionsHolder.empty();
                    mobileHeaderActionsHolder.empty();

                    // Set the the event banner to display in the detail popover if on mobile
                    _showEventBannerInDetail($.isMobile(), false);

                    // Show the detail popover
                    detailContainer.addClass(cssClasses.open);

                    // Show skeleton in the popover initially
                    content.hide();
                    skeleton.show();

                    if ($.isMobile()) {
                        // Push state to history when detail is shown so that browser back button will close detail instead of going back to the previous page
                        window.history.pushState({ rsId: "#detail", counter: 1 }, "");
                    }
                });
            }

            //
            // API function to allow consumers to load content into the detail section
            //
            function loadDetail(detailContent) {

                skeleton.hide();
                content.html(detailContent).show();

                // Attach the list api on html (data attribute) so it can be accessed in the future by 
                // by the dynamically loaded content
                $.js(hostingListIndicator).data(hostingListIndicator, listApiAccessor());

                _setActionBar();

                // Reset validation on any new forms within the loaded detail
                var forms = content.find("form");
                forms.each(function (i, form) {
                    $.validator.resetValidation($(form));
                });

                // if list item was selected via keyboard move focus to first element in detail when it is loaded
                if (whatInput.ask() === "keyboard") {
                    $(detailContainer).find(":tabbable").first().trigger("focus");
                }

                // move focus back to selected item when tabbing back from detail
                $(detailContainer).find(":tabbable").first().on("tabbackward", function (event) {
                    $(`.list-control__list-item.${cssClasses.selected}`).first().trigger("focus");
                    event.preventDefault();
                });
            }

            //
            // API function to allow consumers to scroll the detail to the bottom
            //
            function scrollDetailToBottom() {
                detailContainer.scrollTop(detailContainer[0].scrollHeight);
            }

            //
            // API function to allow consumers to load content into the detail section
            //
            function clearDetail() {
                skeleton.hide();
                content.html(null).show();
                _setActionBar();
            }

            //
            // API function to allow consumers to modify the title of the detail section
            //
            function updateTitle(newTitle) {
                title.text(newTitle);
            }

            return {
                initializeDetail,
                loadDetail,
                scrollDetailToBottom,
                clearDetail,
                updateTitle,
                attachEvents
            };
        }

        // Gets the api instance for the list hosting this detail
        function getHostingList(element) {
            // Find the nearest, previously stashed list api instance for the detail hosting 
            // the provided element.
            var containerWithListApi = $(element).closest(`[data-js~='${hostingListIndicator}']`);
            return containerWithListApi.data(hostingListIndicator);
        }

        var exports = {
            initialize,
            getHostingList
        };

        return exports;
    }
);
